import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtruderScrew = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 110,
	height: 60,
	viewBox: "0 0 110.0 60.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 10.0 0.0 L 90.0 0.0 L 100.0 20.0 L 110.0 20.0 L 110.0 40.0 L 100.0 40.0 L 90.0 60.0 L 10.0 60.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 30.0 L 100.0 30.0 L 90.0 50.0 L 70.0 10.0 L 50.0 50.0 L 30.0 10.0 L 20.0 30.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgExtruderScrew;
